import { load } from './Controllers/BaseController';
import ArticleController from './Controllers/ArticleController';
import SliderController from './Controllers/SliderController';
import MessageController from './Controllers/MessageController';
import LightboxController from './Controllers/LightboxController';
import QuizAnswerController from './Controllers/QuizAnswerController';
import ExpandableWindowController from './Controllers/ExpandableWindowController';

export default load([
  ArticleController,
  SliderController,
  MessageController,
  LightboxController,
  QuizAnswerController,
  ExpandableWindowController,
]);
